import React, { useEffect, useState } from 'react';
import { useSetState } from 'ahooks';

import { IReportPageData } from '@/constants/geo';
import { convertReportDetailToPageData } from '@/utils/geo';

import pcMobileConfig from '@/hocs/pcMobileConfig';
import MobileReport from './components/MobileReport';
import PcReport from './components/PcReport';
import styles from './index.module.less';
import { message, Spin } from 'antd';

interface IProps {
  isMobilePage: boolean;
}

/** GEO 报表页 */
const StaticGEOReport: React.FC<IProps> = (props) => {
  const { isMobilePage } = props;

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useSetState<IReportPageData>({} as IReportPageData);

  // 从public文件夹加载data.json
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/data.json');
        const jsonData = await response.json();
        setData(jsonData);

        const { oemConfig, reportDetail } = jsonData;
        const convertedData = convertReportDetailToPageData({
          reportDetail,
          oemConfig,
        }) as IReportPageData;
        setPageData(convertedData);
      } catch (error) {
        console.error('加载data.json失败:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    document.title = 'GEO搜索推广数据看板';
  }, []);

  if (loading) {
    return (
      <div className={styles['geo_report_loading']}>
        <Spin fullscreen tip="加载中..." />
      </div>
    );
  }

  return isMobilePage ? (
    <MobileReport pageData={pageData} setPageData={(value) => setPageData(value as IReportPageData)} />
  ) : (
    <PcReport pageData={pageData} setPageData={(value) => setPageData(value as IReportPageData)} />
  );
};

export default pcMobileConfig(StaticGEOReport, {
  pcBodyClass: 'geo_report_pc_body',
  mobileBodyClass: 'geo_report_mobile_body',
});
